import { render, staticRenderFns } from "./Browsercheck.vue?vue&type=template&id=9c859256&scoped=true&"
import script from "./Browsercheck.vue?vue&type=script&lang=ts&"
export * from "./Browsercheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c859256",
  null
  
)

export default component.exports